<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <card title="Filtros">
          <div class="content">
            <div class="row">
              <div class="col-md-4">
                <obra-filter
                  v-model="selectedCategoria"
                  @change="submitBuscaCategoria($event)"
                  label="Categoria"
                  nome='nome_categoria'
                  :items='$store.state.categorias'
                ></obra-filter>
              </div>
              <div class="col-md-4">
                <obra-filter
                  v-model="selectedColecao"
                  @change="submitBuscaColecao($event)"
                  label="Coleção"
                  nome='nome_colecao'
                  :items='$store.state.colecoes'
                ></obra-filter>
              </div>
              <div class="col-md-4">
                <obra-filter
                  v-model="selectedTag"
                  @change="submitBuscaTag($event)"
                  label="Tag"
                  nome='nome_tag'
                  :items='$store.state.tags'
                ></obra-filter>
              </div>
            </div>
          </div>
        </card>
        <card>
          <div class="content search">
            <div class="col-md-7 download-csv d-none d-md-block">
              <button
                class="pull-right btn-download-csv btn-sm btn btn-primary"
                v-if="isAdmin"
                @click.prevent.stop="downloadCsv"
              >
                <i class="ti-download"></i> CSV
              </button>
            </div>
            <form @submit.stop.prevent="searchByValue">
              <div class="row">
                <div class="col-md-5">
                  <div class="form-group">
                    <div class="col-md-12">
                      <label>Buscar</label>
                    </div>
                    <div class="col-md-12">
                      <input
                        type="text"
                        name="search"
                        v-model.trim="searchValue"
                        class="form-control border-input"
                        placeholder="Nome / Autor"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </card>
        <table-obras :obras="obras" @filterByTag="submitBuscaTag($event)"></table-obras>
        <pagination :count="count" :limit="limit" :page="page" @changePage="changePage($event)"></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import ObraService from '../services/obra-service'
import { TableObras } from '@/components'
import { Pagination } from '@/components'
import ObraFilter from './Busca/ObraFilter'
import OverlayService from '../services/overlay-service'

import { mapGetters } from 'vuex'

export default {
  components: {
    TableObras,
    Pagination,
    ObraFilter
  },

  data () {
    return {
      obras: [],
      offset: 0,
      searchValue: '',
      limit: 10,
      count: 0,
      page: 0,
      selectedCategoria: null,
      selectedColecao: null,
      selectedTag: null
    }
  },
  computed: {
    ...mapGetters(['isLogged','isAdmin','isPresbiterio'])
  },
  mounted () {
    this.searchObras()
  },
  methods: {

    searchObras () {
      const order = [{ orderBy: 'titulo', direction: 'asc' }]

      const filter = {
        limit: this.limit,
        page: this.page + 1,
        orderBy: order,
        categoria: this.selectedCategoria,
        colecao: this.selectedColecao,
        tag: this.selectedTag,
        search: this.searchValue
      }

      OverlayService.trigger('show', true)

      ObraService.getByTitle(filter)
        .then(response => response.data)
        .then(data => {
          OverlayService.trigger('show', false)
          this.obras = data.data
          this.count = data.total
        })
        .catch(er => OverlayService.trigger('show', false))
    },

    searchByValue () {
      this.page = 0
      this.searchObras()
    },

    changePage (page) {
      this.page = page
      this.searchObras()
    },

    submitBuscaCategoria (categoria) {
      this.selectedCategoria = categoria
      this.page = 0
      return this.searchObras()
    },

    submitBuscaColecao (colecao) {
      this.selectedColecao = colecao
      this.page = 0
      return this.searchObras()
    },

    submitBuscaTag (tag) {
      this.selectedTag = tag
      this.page = 0
      return this.searchObras()
    },

    downloadCsv () {
      OverlayService.trigger('show', true)

      ObraService.getCsv()
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'acervo.csv')
          document.body.appendChild(link)
          link.click()
        })
        .finally(() => {
          OverlayService.trigger('show', false)
        })
    }
  }
}
</script>
<style scoped>
.content.search {
  position: relative;
}
.download-csv {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
